module.exports = __webpack_public_path__ + "static/img/icon_pruebas.7945925c.png";